import React from 'react';
import { Box, Grid } from '@mui/material';


import { ParticipantsStatistics } from '../../components/ParticipantsStatistics/ParticipantsStatistics';
import { statisticVoteData } from '../../components/ParticipantsStatistics/statisticVoteData'
import Rus from '../../components/RusStat/Rus';
import Winners from '../../components/Winners/Winners';
import { winnersData } from '../../components/Winners/winnersData';

import './ArchivePage.css'
import ArchiveMoney from '../../components/ArchiveMoney/ArchiveMoney';

const ArchivePage: React.FC = () => {
   return (
      <div className='archive_page'>
         <ArchiveMoney />
         <Box sx={{ flexGrow: 10 }}>
            <Grid container spacing={2} justifyContent="center" style={{ boxSizing: "border-box" }}>
               {/* компонент отображения текущей статистики участников  */}
               <Grid className='grid_column_stat' item xs={12} md={12}>
                  <ParticipantsStatistics statisticVote={statisticVoteData} />
               </Grid>
            </Grid>

         </Box>
      </div>
   )
}

export default ArchivePage;